import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var Watcher = {
  isValid: function isValid(value) {
    return value !== undefined && value !== null && value !== '' && !value.isProxy && _typeof(value) === 'object' && !Array.isArray(value);
  },
  hasKey: function hasKey(watch, key) {
    return watch && watch.includes(key);
  },
  create: function create(value, watch, callback, key) {
    if (this.isValid(value) && (!key || this.hasKey(watch, key))) {
      return new Proxy(value, this.handler(watch, callback));
    }
    return value;
  },
  handler: function handler(watch, callback) {
    return {
      get: function get(target, key) {
        return Watcher.create(target[key], watch, callback, key);
      },
      set: function set(target, key, value) {
        target[key] = value;
        callback();
        return true;
      }
    };
  }
};
export default Watcher;